var _g, _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 80,
    viewBox: "0 0 70 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_43692_17073)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62 78.5H18C14.4101 78.5 11.5 75.5899 11.5 72V8C11.5 4.41015 14.4101 1.5 18 1.5H44.3787L68.5 25.6213V72C68.5 75.5899 65.5899 78.5 62 78.5Z",
    fill: "white",
    stroke: "#C8D2E1",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 2V20C44 23.3137 46.6863 26 50 26H68",
    stroke: "#C8D2E1",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 38,
    width: 49,
    height: 32,
    rx: 4,
    fill: "#FF1607"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.56459 61V46.4545H12.3032C13.4065 46.4545 14.3463 46.6652 15.1228 47.0866C15.8993 47.5033 16.4912 48.0833 16.8984 48.8267C17.3103 49.5653 17.5163 50.4176 17.5163 51.3835C17.5163 52.3494 17.308 53.2017 16.8913 53.9403C16.4746 54.679 15.8709 55.2543 15.0802 55.6662C14.2942 56.0781 13.3425 56.2841 12.2251 56.2841H8.56744V53.8196H11.7279C12.3198 53.8196 12.8075 53.7178 13.191 53.5142C13.5793 53.3059 13.8681 53.0194 14.0575 52.6548C14.2516 52.2855 14.3487 51.8617 14.3487 51.3835C14.3487 50.9006 14.2516 50.4792 14.0575 50.1193C13.8681 49.7547 13.5793 49.473 13.191 49.2741C12.8028 49.0705 12.3103 48.9688 11.7137 48.9688H9.63988V61H6.56459ZM24.2701 61H19.1138V46.4545H24.3127C25.7757 46.4545 27.0352 46.7457 28.0911 47.3281C29.147 47.9058 29.959 48.7367 30.5272 49.821C31.1001 50.9053 31.3865 52.2027 31.3865 53.7131C31.3865 55.2282 31.1001 56.5303 30.5272 57.6193C29.959 58.7083 29.1422 59.544 28.0769 60.1264C27.0163 60.7088 25.7473 61 24.2701 61ZM22.1891 58.3651H24.1422C25.0513 58.3651 25.816 58.2041 26.4363 57.8821C27.0613 57.5554 27.53 57.0511 27.8425 56.3693C28.1597 55.6828 28.3184 54.7973 28.3184 53.7131C28.3184 52.6383 28.1597 51.7599 27.8425 51.0781C27.53 50.3963 27.0636 49.8944 26.4434 49.5724C25.8231 49.2505 25.0584 49.0895 24.1493 49.0895H22.1891V58.3651ZM33.2646 61V46.4545H42.8953V48.9901H36.3399V52.456H42.2561V54.9915H36.3399V61H33.2646Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_43692_17073"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 80,
    fill: "white",
    transform: "translate(10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.a894894eaae44c9e79290495db734213.svg";
export { ForwardRef as ReactComponent };